import $ from "jquery";
import app, { u_, vuwer ,csl } from "@@assets/scripts/common";
import "@@assets/klass/VuwSlider";

const popupKey = "item-image-slides";
const vuwName = `popup-${popupKey}`;
const sliderOptions = {
	autoplay: false,
	effect: "slide",
	loop: true,
	slidesPerView: 1.5,
	centeredSlides : true
};

app.onReady(() => {
	const $elm = $("<div/>").append(
		$("<div/>").addClass("content-header").append(
			$("<a/>").attr("href", "./").addClass("btn-close")
		)
	);
	
	app.popup.addContent(popupKey, $elm);
	
	$elm.on("click", ".btn-close", e => {
		e.preventDefault();
		app.popup.hideContents(popupKey, () => {
			const currentVuw = vuwer.get(vuwName);
			if(currentVuw) {
				currentVuw.destroySlider();
				vuwer.remove(vuwName);
			}
		});
	});
});

async function showPopupSlides($slideWrapper, initialSlide) {
	const $popupElm = app.popup.getContents(popupKey);
	if(!$popupElm) {
		return false;
	}
	
	u_.isInteger(initialSlide) || (initialSlide = 0);
	
	// show popup
	await app.popup.showContents(popupKey);

	vuwer.add(vuwName, {
		vuwType: "slider",
		sliderOptions: { ...sliderOptions, initialSlide },
		selector() {
			const $pagination = $("<div/>").addClass("pagination");
			const $btnNext = $("<div/>").addClass("btn-next");
			const $btnPrev = $("<div/>").addClass("btn-prev");
			
			this.sliderOptions.pagination = {
				el: $pagination.get(0),
				type: "fraction"
			};
			
			this.sliderOptions.navigation = {
				nextEl: $btnNext.get(0),
				prevEl: $btnPrev.get(0)
			};
			
			return $("<div/>").addClass("content-body").append(
				$slideWrapper, $pagination, $btnNext, $btnPrev
			).appendTo($popupElm);
		},
		onReadyLast() {
			csl.log.orange("onReadyLast:swiper.update");
			this.swiper.update();
			this.swiper.slideReset(0, false);
		}
	});
	
	const vuwSlider = vuwer.get(vuwName);
	await vuwSlider.getReady();
	
	return vuwSlider;
}

export { showPopupSlides };
